/*
  Anmeldung für Fachbetriebe, Änderungsauftrag 4 (27.09.2026): erst Formular, dann Mail bestätigen.
  Markup: snippets/installateur-anmeldung-v4.liquid. Funktionen: betrieb-vorschlag,
  betrieb-anmelden (ablauf "v4" und /bestaetigen), anmeldung-nachweis.

  Ablauf
    Suche -> Schritt 1 (Betrieb) -> Schritt 2 (Leistungen, Mail) -> Absenden.
    Antwort "bestaetigt" (schon mit derselben Mail eingeloggt): Danke.
    Antwort "unbestaetigt": Code im Sitzungsspeicher dieses Tabs (offenMerken), Weiterleitung zum
    Shopify Login mit login_hint und Ruecksprung auf ?bestaetigen=<Code> (Ersatzweg 3.4).
    Zurueck und eingeloggt: /bestaetigen mit Code; ohne Code (Ruecksprung verlor ihn)
    genuegt die gleiche Mail, die Funktion prueft sie.

  Messung (PostHog ueber window.soMessen, nur mit Einwilligung): anmeldung_schritt1_weiter,
  anmeldung_formular_gesendet, anmeldung_bestaetigung_gestartet, anmeldung_mail_bestaetigt,
  anmeldung_andere_mail, je mit quelle_code. Keine Formularinhalte, keine Mailadressen.
*/
(function () {
  'use strict';

  var MELDUNGEN = {
    firma: 'Bitte den Firmennamen angeben.',
    rechtsform: 'Bitte die Rechtsform wählen.',
    registernummer: 'Bitte die Registernummer angeben, zum Beispiel HRB 12345.',
    registergericht: 'Bitte das Amtsgericht angeben, zum Beispiel Nürnberg.',
    strasse: 'Bitte Straße und Hausnummer angeben.',
    plz: 'Bitte eine fünfstellige Postleitzahl angeben.',
    plz_unbekannt: 'Diese Postleitzahl kennen wir nicht. Bitte noch einmal prüfen.',
    ort: 'Bitte den Ort angeben.',
    website: 'Bitte die Website angeben, zum Beispiel www.deinbetrieb.de.',
    gewerke: 'Bitte mindestens eine Leistung wählen.',
    email: 'Bitte die Mailadresse prüfen.',
    datenschutz: 'Bitte die Nutzungsbedingungen für Fachbetriebe und den Datenschutz akzeptieren.',
    partnerbedingungen: 'Bitte die Nutzungsbedingungen für Fachbetriebe und den Datenschutz akzeptieren.',
    zu_viele: 'Das waren gerade viele Anmeldungen von deinem Anschluss. Bitte versuch es in einer Stunde noch einmal.',
    zu_viele_domain: 'Mit dieser Mailadresse oder Domain gab es heute schon mehrere Anmeldungen. Bitte bestätige eine davon oder versuch es morgen noch einmal.',
    pruefung: 'Die Sicherheitsprüfung hat nicht geklappt. Bitte lade die Seite neu.',
    schon_mitglied: 'Dein Kundenkonto gehört schon zu einem Betrieb. Für einen weiteren Betrieb brauchst du ein eigenes Konto.',
    mw_code: 'Der Link ist nicht mehr gültig. Ändere die Adresse im Partnerbereich bitte noch einmal.',
    mw_erledigt: 'Diese Mailadresse ist schon bestätigt. Melde dich mit ihr an, um in den Partnerbereich zu kommen.',
    mw_passt_nicht: 'Mit der neuen Adresse passt die Verifizierung noch nicht, deshalb gilt weiter die bisherige Adresse.',
    mw_nicht_erreichbar: 'Eine Quelle war gerade nicht erreichbar. Bitte lade die Seite in ein paar Minuten neu.',
    mw_andere_mail: 'Du bist mit einer anderen Adresse angemeldet. Bitte melde dich mit der neuen Adresse an.',
    logo_gross: 'Das Logo ist zu groß. Bitte wähle ein kleineres Bild.',
    logo_typ: 'Das Logo muss ein PNG, JPG oder WebP sein.',
    email_vorhanden: 'Mit dieser Mailadresse ist schon ein Betrieb angemeldet. Melde dich im Partnerbereich an oder schreib uns an admin@solaroutlet.de.',
    code: 'Der Bestätigungslink ist nicht mehr gültig. Bitte melde deinen Betrieb noch einmal an, deine Angaben lassen sich schnell eingeben.',
    abgelaufen: 'Der Bestätigungslink ist abgelaufen. Bitte melde deinen Betrieb noch einmal an.',
    kein_antrag: 'Zu dieser Mailadresse haben wir keine offene Anmeldung gefunden.',
    server: 'Bei uns ist etwas schiefgegangen. Bitte versuch es gleich noch einmal oder schreib an info@solaroutlet.de.'
  };
  var FREEMAIL = ['gmail.com', 'googlemail.com', 'web.de', 'gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch', 't-online.de', 'outlook.com', 'outlook.de',
    'hotmail.com', 'hotmail.de', 'live.com', 'live.de', 'msn.com', 'yahoo.com', 'yahoo.de', 'icloud.com', 'me.com', 'mac.com', 'aol.com',
    'aol.de', 'freenet.de', 'posteo.de', 'mailbox.org', 'protonmail.com', 'proton.me', 'arcor.de', 'online.de', '1und1.de', 'vodafone.de',
    'email.de', 'mail.de', 'kabelmail.de', 'gmx.com'];
  var REGISTER = ['egbr', 'ek', 'gmbh', 'ug', 'gmbh_co_kg', 'kg'];
  var ERLAUBT = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function websiteLesbar(w) {
    w = (w || '').trim();
    if (!w || /\s/.test(w)) return false;
    try { var u = new URL(/^https?:\/\//i.test(w) ? w : 'https://' + w); return /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(u.hostname); } catch (e) { return false; }
  }

  // Offene Anmeldung (Code, Formularmail, Upload) im Sitzungsspeicher dieses Tabs, damit die Seite
  // nach dem Neuladen bei „Fast geschafft“ bleibt (Michel 27.09., weicht von Ä4 3.x „nur im
  // Speicher der Seite“ ab). Weg beim Schliessen des Tabs, nach der Bestaetigung und nach 7 Tagen.
  // Der Code allein bestaetigt nichts, dazu braucht es den Login mit genau dieser Mail.
  var OFFEN = 'inst_anm4_offen';
  function offenMerken(neu) {
    try {
      if (neu === null) { sessionStorage.removeItem(OFFEN); sessionStorage.removeItem('inst_anm4_mail'); return null; }
      if (neu) { neu.zeit = Date.now(); sessionStorage.setItem(OFFEN, JSON.stringify(neu)); return neu; }
      var o = JSON.parse(sessionStorage.getItem(OFFEN) || 'null');
      if (!o || !o.code || Date.now() - (o.zeit || 0) > 7 * 864e5) return null;
      return o;
    } catch (e) { return null; }
  }

  // Entwurf des Formulars (Schritt und Felder) im Sitzungsspeicher des Tabs, damit ein Neuladen
  // nicht zurueck zur Suche springt (Michel 27.09.). Mit dem Haken zur Zustimmung. Weg beim
  // Schliessen des Tabs und nach der Bestaetigung.
  var ENTWURF = 'inst_anm4_entwurf';
  var ENTWURF_FELDER = ['firma', 'rechtsform', 'registernummer', 'registergericht', 'strasse', 'plz', 'ort', 'website', 'google_place_id', 'email', 'radius_km'];
  // Der Zustimmungshaken wird mit gemerkt (Michel 27.09.)
  function entwurfLesen() {
    try { return JSON.parse(sessionStorage.getItem(ENTWURF) || 'null'); } catch (e) { return null; }
  }
  function entwurfLoeschen() {
    try { sessionStorage.removeItem(ENTWURF); } catch (e) { /* ohne Speicher */ }
  }

  var MW = 'inst_anm4_mailwechsel';
  function mwMerken(neu) {
    try {
      if (neu === null) { sessionStorage.removeItem(MW); return ''; }
      if (neu) { sessionStorage.setItem(MW, neu); return neu; }
      return sessionStorage.getItem(MW) || '';
    } catch (e) { return neu || ''; }
  }

  // Abmelden und direkt zur Shopify Anmeldung mit vorbelegter Mail. Der Logout kennt nur
  // return_url (return_to fuehrt auf die Startseite, nachgemessen 28.09.2026).
  function abmeldenUndAnmelden(el, zurueck, mail) {
    var login = '/customer_authentication/login?return_to=' + encodeURIComponent(zurueck) + (mail ? '&login_hint=' + encodeURIComponent(mail) : '');
    var basis = el.getAttribute('data-abmelden') || '/account/logout';
    location.href = basis + (basis.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + encodeURIComponent(login);
  }

  // Zugeschnittenes Logo (data-URL) im Sitzungsspeicher des Tabs, wie der Entwurf
  var LOGO = 'inst_anm4_logo';
  function logoMerken(neu) {
    try {
      if (neu === null) { sessionStorage.removeItem(LOGO); return ''; }
      if (neu) { sessionStorage.setItem(LOGO, neu); return neu; }
      return sessionStorage.getItem(LOGO) || '';
    } catch (e) { return neu || ''; }
  }

  function Anmeldung(el) {
    var ich = this;
    this.el = el;
    this.url = (el.getAttribute('data-supabase-url') || '').replace(/\/+$/, '');
    this.schluessel = el.getAttribute('data-supabase-key') || '';
    this.form = el.querySelector('[data-anm4-formular]');
    this.code = null;           // dazu im Sitzungsspeicher des Tabs, siehe offenMerken
    this.formularMail = '';
    this.upload = false;
    var such = new URLSearchParams(location.search);
    this.quelle = (such.get('q') || '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 40);
    this.form.querySelector('[name="quelle_code"]').value = this.quelle;
    this.kunde = el.getAttribute('data-eingeloggt') === '1' ? {
      kunde_id: el.getAttribute('data-kunde-id'), kunde_zeit: el.getAttribute('data-kunde-zeit'),
      kunde_mail: el.getAttribute('data-kunde-mail'), kunde_sig: el.getAttribute('data-kunde-sig'),
      kunde_sig_mail: el.getAttribute('data-kunde-sig-mail')
    } : null;

    this.einrichten();
    this.logoEinrichten();

    // Mailadresse aendern (Link aus dem Partnerbereich); Code auch im Sitzungsspeicher, falls der Ruecksprung ihn verliert
    var mw = such.get('mail_bestaetigen') || mwMerken();
    if (mw && /^[A-Za-z0-9_-]{20,100}$/.test(mw)) { this.mailwechsel(mw); return; }

    // Schritt 4 nach dem Neuladen wieder zeigen, nicht an den Start springen (Michel 29.09.2026)
    var s4 = schritt4Merken();
    if (s4 && this.kunde) { this.danke({ upload: s4.pflicht }, s4); return; }
    if (s4) schritt4Merken(null);

    var offen = offenMerken();
    var code = such.get('bestaetigen') || (offen && offen.code);
    if (code && /^[A-Za-z0-9_-]{20,100}$/.test(code)) {
      this.code = code;
      // Neu geladen, Zurueck vom Login oder Link aus der Erinnerung: Mail aus dem Sitzungsspeicher
      if (offen && offen.code === code) { this.formularMail = offen.mail || ''; this.upload = !!offen.upload; }
      if (this.kunde) this.bestaetigen(); else this.bestaetigenAnzeigen(false);
      return;
    }
    if (this.kunde && el.getAttribute('data-mitglied') !== '1') {
      // Ruecksprung ohne Code (Shopify hat den Parameter verworfen): offene Anmeldung mit genau dieser Mail?
      this.bestaetigen(true);
      return;
    }
    this.formularZeigen();
  }

  Anmeldung.prototype.formularZeigen = function () {
    if (this.el.getAttribute('data-mitglied') === '1') { this.zustand('mitglied'); return; }
    this.zustand('formular');
    var e = entwurfLesen();
    if (!e || !e.schritt || e.schritt === 'suche') return;
    var ich = this;
    var w = e.felder || {};
    this.schritt1(e.hinweis || '', w, true);
    ['rechtsform', 'registernummer', 'registergericht', 'email'].forEach(function (n) {
      if (w[n] != null && ich.feld(n)) ich.feld(n).value = w[n];
    });
    this.feld('rechtsform').dispatchEvent(new Event('change', { bubbles: true }));
    this.feld('email').dispatchEvent(new Event('input', { bubbles: true }));
    (e.gewerke || []).forEach(function (g) {
      var h = ich.form.querySelector('[name="gewerke"][value="' + g + '"]');
      if (h) h.checked = true;
    });
    if (this.feld('zustimmung')) this.feld('zustimmung').checked = !!e.zustimmung;
    if (e.schritt === '2') this.weiter(true);
  };

  Anmeldung.prototype.entwurfSpeichern = function (schritt) {
    var ich = this;
    if (this.form.hidden) return; // nur aus dem sichtbaren Formular, nie einen leeren Stand ueberschreiben
    try {
      var alt = entwurfLesen() || {};
      var felder = {};
      ENTWURF_FELDER.forEach(function (n) { var x = ich.feld(n); if (x) felder[n] = x.value; });
      sessionStorage.setItem(ENTWURF, JSON.stringify({
        schritt: schritt || alt.schritt || 'suche',
        hinweis: this.form.querySelector('[data-anm4-google-hinweis]').textContent || '',
        felder: felder,
        gewerke: [].slice.call(this.form.querySelectorAll('[name="gewerke"]:checked')).map(function (x) { return x.value; }),
        zustimmung: !!(this.feld('zustimmung') && this.feld('zustimmung').checked)
      }));
    } catch (e) { /* ohne Speicher */ }
  };

  Anmeldung.prototype.messen = function (name, mehr) {
    if (typeof window.soMessen !== 'function') return;
    var p = { quelle_code: this.quelle || '' };
    for (var k in (mehr || {})) p[k] = mehr[k];
    window.soMessen(name, p);
  };

  Anmeldung.prototype.zustand = function (name) {
    this.el.querySelectorAll('[data-anm4-zustand]').forEach(function (z) { z.hidden = z.getAttribute('data-anm4-zustand') !== name; });
  };

  Anmeldung.prototype.feld = function (n) { return this.form.querySelector('[name="' + n + '"]'); };

  Anmeldung.prototype.melden = function (text, wo) {
    var f = wo || this.form.querySelector('[data-anm4-fehler]');
    if (!f) return;
    f.textContent = text || '';
    f.hidden = !text;
    if (text) f.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  Anmeldung.prototype.einrichten = function () {
    var ich = this;
    var f = this.form;
    // Rechtsform: Register nur bei eingetragenen Formen, dann Pflicht
    var rf = f.querySelector('[data-anm4-rechtsform]');
    var reg = f.querySelector('[data-anm4-register]');
    rf.addEventListener('change', function () {
      var an = REGISTER.indexOf(rf.value) > -1;
      reg.hidden = !an;
      ich.feld('registernummer').required = an;
      ich.feld('registergericht').required = an;
    });
    // Freemail-Hinweis
    var mail = f.querySelector('[data-anm4-mail]');
    var hinweis = f.querySelector('[data-anm4-freemail]');
    var pruefeMail = function () {
      var dom = (mail.value.split('@')[1] || '').toLowerCase().trim();
      hinweis.hidden = FREEMAIL.indexOf(dom) === -1;
    };
    mail.addEventListener('input', pruefeMail);
    pruefeMail();
    // Website als Adresse lesbar
    var web = f.querySelector('[data-anm4-website]');
    web.addEventListener('input', function () { web.setCustomValidity(''); });

    // Suche
    f.querySelector('[data-anm4-suchen]').addEventListener('click', function () { ich.suchen(); });
    [f.querySelector('[data-anm4-such-firma]'), f.querySelector('[data-anm4-such-plz]')].forEach(function (x) {
      x.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ich.suchen(); } });
    });
    var plzAusLink = new URLSearchParams(location.search).get('plz');
    if (plzAusLink && /^[0-9]{5}$/.test(plzAusLink)) f.querySelector('[data-anm4-such-plz]').value = plzAusLink;

    f.querySelector('[data-anm4-weiter]').addEventListener('click', function () { ich.weiter(); });
    // Zurueck: Schritt 1 -> Suche, Schritt 2 -> Schritt 1
    f.querySelectorAll('[data-anm4-zurueck]').forEach(function (k) {
      k.addEventListener('click', function () {
        if (k.getAttribute('data-anm4-zurueck') === '1') { ich.oeffne1(); return; }
        f.querySelector('[data-anm4-schritt="1"]').hidden = true;
        f.querySelector('[data-anm4-schritt="2"]').hidden = true;
        f.querySelector('[data-anm4-fortschritt]').hidden = true;
        f.querySelector('[data-inst-vorschlaege]').hidden = true;
        var suche = f.querySelector('[data-anm4-suche]');
        suche.hidden = false;
        ich.melden('');
        ich.entwurfSpeichern('suche');
        suche.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    });
    // Jede Eingabe im Entwurf festhalten (Neuladen bleibt im Schritt)
    var merken = function (e) { if (e.target.closest('[data-anm4-schritt]')) ich.entwurfSpeichern(); };
    f.addEventListener('input', merken);
    f.addEventListener('change', merken);
    f.querySelector('[data-anm4-aendern]').addEventListener('click', function () { ich.oeffne1(); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!f.querySelector('[data-anm4-schritt="2"]').hidden) ich.absenden(); else ich.weiter();
    });
    f.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') return;
      if (f.querySelector('[data-anm4-schritt="1"]').contains(e.target)) { e.preventDefault(); ich.weiter(); }
    });

    this.el.querySelector('[data-anm4-login]').addEventListener('click', function (e) { e.preventDefault(); ich.zumLogin(); });
    this.el.querySelector('[data-anm4-neu]').addEventListener('click', function () {
      // Zurueck von „Fast geschafft“ zu Schritt 2, die Angaben kommen aus dem Entwurf
      offenMerken(null); ich.code = null;
      if (history.replaceState) history.replaceState(null, '', location.pathname + (ich.quelle ? '?q=' + encodeURIComponent(ich.quelle) : ''));
      ich.formularZeigen();
      var s2 = ich.form.querySelector('[data-anm4-schritt="2"]');
      (s2.hidden ? ich.el : s2).scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    var ab = this.el.querySelector('[data-anm4-abmelden]');
    if (ab) ab.addEventListener('click', function (e) { e.preventDefault(); ich.abmelden(); });
    this.uploadEinrichten();
  };

  Anmeldung.prototype.suchen = function () {
    var ich = this;
    var firma = (this.form.querySelector('[data-anm4-such-firma]').value || '').trim();
    var plz = (this.form.querySelector('[data-anm4-such-plz]').value || '').trim();
    var kasten = this.form.querySelector('[data-inst-vorschlaege]');
    if (firma.length < 2 || !/^[0-9]{5}$/.test(plz)) { this.melden('Bitte Firmenname und fünfstellige Postleitzahl eingeben.'); return; }
    this.melden('');
    kasten.hidden = false;
    kasten.innerHTML = '<p class="inst-vorschlaege__laedt">Suche bei Google …</p>';
    fetch(this.url + '/functions/v1/betrieb-vorschlag', {
      method: 'POST', headers: { apikey: this.schluessel, 'Content-Type': 'application/json' },
      body: JSON.stringify({ firma: firma, plz: plz })
    }).then(function (r) { return r.json(); }).then(function (j) {
      // Die Suche verschwindet mit Schritt 1, der Grund steht deshalb als Hinweis in Schritt 1
      if (j.status === 'fehler') {
        kasten.hidden = true;
        ich.schritt1(j.grund === 'zu_viele'
          ? 'Die Google Suche ist gerade ausgelastet. Bitte trag deinen Betrieb selbst ein.'
          : 'Die Google Suche hat nicht geklappt. Bitte trag deinen Betrieb selbst ein.', { firma: firma, plz: plz });
        return;
      }
      var liste = (j.vorschlaege || []).filter(function (v) { return !v.geschlossen; }).slice(0, 5);
      if (!liste.length) {
        kasten.hidden = true;
        ich.schritt1('Bei Google haben wir keinen passenden Eintrag gefunden. Bitte trag deinen Betrieb selbst ein.', { firma: firma, plz: plz });
        return;
      }
      kasten.innerHTML = '<p class="inst-vorschlaege__titel">Ist das dein Betrieb?</p>' + liste.map(function (v, i) {
        return '<button type="button" class="inst-vorschlag" data-i="' + i + '"><strong>' + esc(v.name) + '</strong><span>' + esc(v.adresse) + '</span>' +
          (v.webseite ? '<small>' + esc(v.webseite) + '</small>' : '') + '</button>';
      }).join('') + '<button type="button" class="inst-vorschlag inst-vorschlag--keiner" data-i="-1">Nicht dabei, selbst eingeben</button>';
      kasten.querySelectorAll('[data-i]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = liste[Number(b.getAttribute('data-i'))];
          kasten.hidden = true;
          if (v) ich.schritt1('Von Google übernommen: ' + v.name + '. Bitte prüfe die Angaben.', { firma: v.name, strasse: v.strasse, plz: v.plz, ort: v.ort, website: v.webseite, google_place_id: v.id });
          else ich.schritt1('', { firma: firma, plz: plz });
        });
      });
    }).catch(function () {
      kasten.hidden = true;
      ich.schritt1('Die Google Suche hat nicht geklappt. Bitte trag deinen Betrieb selbst ein.', { firma: firma, plz: plz });
    });
  };

  Anmeldung.prototype.schritt1 = function (hinweis, werte, wiederher) {
    var ich = this;
    werte = werte || {};
    ['firma', 'strasse', 'plz', 'ort', 'website', 'google_place_id'].forEach(function (n) {
      if (werte[n] != null && werte[n] !== '') ich.feld(n).value = werte[n];
      else if (n === 'google_place_id') ich.feld(n).value = '';
    });
    var h = this.form.querySelector('[data-anm4-google-hinweis]');
    h.textContent = hinweis || ''; h.hidden = !hinweis;
    this.form.querySelector('[data-anm4-suche]').hidden = true;
    this.form.querySelector('[data-anm4-fortschritt]').hidden = false;
    this.oeffne1(wiederher);
  };

  // Vier Schritte (Michel 29.09.2026): 1 und 2 im Formular, 3 Login („Fast geschafft“), 4 nach dem Login
  var SCHRITTE = ['', 'Dein Betrieb', 'Leistungen und Kontakt', 'Login', 'Nachweise'];
  Anmeldung.prototype.anzeige = function (n) {
    this.form.querySelector('[data-anm4-schritt-anzeige]').textContent = 'Schritt ' + n + ' von 4 · ' + SCHRITTE[n];
    this.form.querySelector('[data-anm4-balken]').style.width = (n * 25) + '%';
  };

  Anmeldung.prototype.oeffne1 = function (wiederher) {
    var s1 = this.form.querySelector('[data-anm4-schritt="1"]');
    s1.hidden = false;
    s1.querySelector('[data-anm4-auf]').hidden = false;
    s1.querySelector('[data-anm4-zu]').hidden = true;
    this.form.querySelector('[data-anm4-schritt="2"]').hidden = true;
    this.anzeige(1);
    this.melden('');
    var erstes = s1.querySelector('input:not([type=hidden]), select');
    if (erstes) { try { erstes.focus({ preventScroll: true }); } catch (e) { erstes.focus(); } }
    if (!wiederher) s1.scrollIntoView({ block: 'start', behavior: 'smooth' });
    this.entwurfSpeichern('1');
  };

  Anmeldung.prototype.weiter = function (wiederher) {
    var s1 = this.form.querySelector('[data-anm4-schritt="1"]');
    var web = this.feld('website');
    web.setCustomValidity(websiteLesbar(web.value) ? '' : MELDUNGEN.website);
    var felder = s1.querySelectorAll('input, select');
    for (var i = 0; i < felder.length; i++) {
      if (felder[i].type === 'hidden' || felder[i].closest('[hidden]')) continue;
      if (!felder[i].checkValidity()) { if (!wiederher) felder[i].reportValidity(); return; }
    }
    var rf = this.feld('rechtsform');
    var zus = esc(this.feld('firma').value) + ' (' + esc(rf.options[rf.selectedIndex].text) + ')<br>' +
      esc(this.feld('strasse').value) + ', ' + esc(this.feld('plz').value) + ' ' + esc(this.feld('ort').value) + '<br>' + esc(this.feld('website').value);
    s1.querySelector('[data-anm4-zusammenfassung]').innerHTML = zus;
    s1.querySelector('[data-anm4-auf]').hidden = true;
    s1.querySelector('[data-anm4-zu]').hidden = false;
    var s2 = this.form.querySelector('[data-anm4-schritt="2"]');
    s2.hidden = false;
    this.anzeige(2);
    this.entwurfSpeichern('2');
    if (wiederher) return;
    this.messen('anmeldung_schritt1_weiter');
    s2.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  Anmeldung.prototype.daten = function () {
    var f = this.form;
    var d = {
      ablauf: 'v4',
      fax: this.feld('fax').value,
      google_place_id: this.feld('google_place_id').value,
      quelle_code: this.quelle,
      firma: this.feld('firma').value.trim(),
      rechtsform: this.feld('rechtsform').value,
      registernummer: this.feld('registernummer').value.trim(),
      registergericht: this.feld('registergericht').value.trim(),
      strasse: this.feld('strasse').value.trim(),
      plz: this.feld('plz').value.trim(),
      ort: this.feld('ort').value.trim(),
      website: this.feld('website').value.trim(),
      email: this.feld('email').value.trim().toLowerCase(),
      radius_km: Number(this.feld('radius_km').value) || 50,
      logo: this.logo ? { daten: this.logo } : undefined,
      // Ein Haken fuer beides, die Funktion prueft weiter beide Felder
      datenschutz: this.feld('zustimmung').checked,
      partnerbedingungen: this.feld('zustimmung').checked,
      gewerke: [].slice.call(f.querySelectorAll('[name="gewerke"]:checked')).map(function (x) { return x.value; })
    };
    if (this.kunde) for (var k in this.kunde) d[k] = this.kunde[k];
    return d;
  };

  Anmeldung.prototype.absenden = function () {
    var ich = this;
    var s2 = this.form.querySelector('[data-anm4-schritt="2"]');
    if (!s2.querySelector('[name="gewerke"]:checked')) { this.melden(MELDUNGEN.gewerke); return; }
    var felder = s2.querySelectorAll('input[required]');
    for (var i = 0; i < felder.length; i++) if (!felder[i].checkValidity()) { felder[i].reportValidity(); return; }
    var knopf = this.form.querySelector('[data-anm4-absenden]');
    knopf.disabled = true; knopf.classList.add('loading');
    this.melden('');
    var d = this.daten();
    this.formularMail = d.email;
    fetch(this.url + '/functions/v1/betrieb-anmelden', {
      method: 'POST', headers: { apikey: this.schluessel, 'Content-Type': 'application/json' }, body: JSON.stringify(d)
    }).then(function (r) { return r.json().catch(function () { return {}; }); }).then(function (j) {
      if (j.status === 'bestaetigt') {
        ich.messen('anmeldung_formular_gesendet', { bestaetigt: true });
        ich.messen('anmeldung_mail_bestaetigt');
        ich.danke(j);
      } else if (j.status === 'unbestaetigt' && j.code) {
        ich.code = j.code;
        ich.upload = !!j.upload;
        offenMerken({ code: ich.code, mail: ich.formularMail, upload: ich.upload });
        ich.messen('anmeldung_formular_gesendet', { bestaetigt: false });
        ich.bestaetigenAnzeigen(true);
      } else if (j.status === 'eingereicht') {
        ich.danke({}); // Spamfalle
      } else {
        ich.melden(MELDUNGEN[j.grund] || MELDUNGEN.server);
      }
    }).catch(function () { ich.melden(MELDUNGEN.server); })
      .then(function () { knopf.disabled = false; knopf.classList.remove('loading'); });
  };

  Anmeldung.prototype.loginAdresse = function () {
    var zurueck = location.pathname + '?bestaetigen=' + encodeURIComponent(this.code || '') + (this.quelle ? '&q=' + encodeURIComponent(this.quelle) : '');
    var ziel = '/customer_authentication/login?return_to=' + encodeURIComponent(zurueck);
    if (this.formularMail) ziel += '&login_hint=' + encodeURIComponent(this.formularMail);
    return ziel;
  };

  Anmeldung.prototype.bestaetigenAnzeigen = function (automatisch) {
    var ich = this;
    this.zustand('bestaetigen');
    // Die Mail wird hier nicht angezeigt (Michel 27.09.), sie steht nur vorbelegt auf der Anmeldeseite
    this.el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    // Keine automatische Weiterleitung (Michel 27.09.): erst mit Klick auf „Mail bestätigen“
  };

  Anmeldung.prototype.zumLogin = function () {
    this.messen('anmeldung_bestaetigung_gestartet');
    location.href = this.loginAdresse();
  };

  Anmeldung.prototype.abmelden = function () {
    // Abmelden und mit der Formularmail neu anmelden; danach zurueck auf die Seite mit dem Code
    var zurueck = location.pathname + (this.code ? '?bestaetigen=' + encodeURIComponent(this.code) : '');
    abmeldenUndAnmelden(this.el, zurueck, this.formularMail);
  };

  Anmeldung.prototype.bestaetigen = function (ohneCode) {
    var ich = this;
    this.zustand('pruefen');
    var d = {};
    for (var k in this.kunde) d[k] = this.kunde[k];
    if (!ohneCode && this.code) d.code = this.code;
    fetch(this.url + '/functions/v1/betrieb-anmelden/bestaetigen', {
      method: 'POST', headers: { apikey: this.schluessel, 'Content-Type': 'application/json' }, body: JSON.stringify(d)
    }).then(function (r) { return r.json().catch(function () { return {}; }); }).then(function (j) {
      if (j.status === 'bestaetigt') {
        if (!j.schon) ich.messen('anmeldung_mail_bestaetigt');
        ich.upload = !!j.upload;
        ich.danke(j);
        if (history.replaceState) history.replaceState(null, '', location.pathname);
        return;
      }
      if (ohneCode) { ich.formularZeigen(); return; }
      if (j.grund === 'andere_mail') { ich.messen('anmeldung_andere_mail'); ich.zustand('andere_mail'); return; }
      if (j.grund === 'schon_mitglied') { offenMerken(null); ich.zustand('mitglied'); return; }
      if (j.grund === 'code') offenMerken(null); // abgelaufen oder verbraucht: beim naechsten Laden wieder das Formular
      ich.zustand('bestaetigen');
      ich.melden(MELDUNGEN[j.grund] || MELDUNGEN.server, ich.el.querySelector('[data-anm4-bestaetigen-fehler]'));
    }).catch(function () {
      ich.zustand('bestaetigen');
      ich.melden(MELDUNGEN.server, ich.el.querySelector('[data-anm4-bestaetigen-fehler]'));
    });
  };

  /* Logo auswaehlen und zuschneiden (Michel 28.09.2026). Das ganze Bild liegt eingepasst in einer
     quadratischen Buehne, darueber ein quadratischer Rahmen: verschieben und an den Ecken
     groesser oder kleiner ziehen. Der Rahmen darf bis zur ganzen Buehne wachsen, so bleiben auch
     breite Logos vollstaendig. Gespeichert wird nur der Rahmeninhalt aus dem Originalbild,
     480 x 480 px als PNG (durchsichtig bleibt durchsichtig). Quadratisch, weil das Verzeichnis
     Logos quadratisch zeigt. */
  /* 29.09.2026 (Michel): wieder in Schritt 2, das Logo geht mit der Anmeldung mit. Die Funktion
     anmeldung-nachweis kann Logos nach dem Login weiter setzen (aktion "logo"), genutzt wird das hier nicht. */
  Anmeldung.prototype.logoEinrichten = function () {
    var ich = this;
    var box = this.el.querySelector('[data-anm4-logo]');
    if (!box) return;
    var q = function (s) { return box.querySelector(s); };
    var leer = q('[data-anm4-logo-leer]'), schnitt = q('[data-anm4-logo-zuschnitt]'), fertig = q('[data-anm4-logo-fertig]');
    var datei = q('[data-anm4-logo-datei]'), canvas = q('[data-anm4-logo-canvas]'), buehne = q('[data-anm4-logo-buehne]');
    var rahmen = q('[data-anm4-logo-rahmen]');
    var ctx = canvas.getContext('2d');
    var MIN = 0.08;                                   // kleinster Rahmen, Anteil der Buehne
    var bild = null, lage = null;                     // lage: Bild in der Buehne (Anteile 0..1)
    var r = { x: 0, y: 0, s: 1 };                     // Rahmen in Anteilen der Buehne
    var zug = null;
    var zeige = function (was) { leer.hidden = was !== 'leer'; schnitt.hidden = was !== 'schnitt'; fertig.hidden = was !== 'fertig'; };
    var klemmen = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var rahmenSetzen = function () {
      rahmen.style.left = (r.x * 100) + '%'; rahmen.style.top = (r.y * 100) + '%';
      rahmen.style.width = (r.s * 100) + '%'; rahmen.style.height = (r.s * 100) + '%';
    };
    var zeichnen = function () {
      var w = canvas.width, sk = Math.min(w / bild.naturalWidth, w / bild.naturalHeight);
      var bw = bild.naturalWidth * sk, bh = bild.naturalHeight * sk;
      lage = { x: (w - bw) / 2 / w, y: (w - bh) / 2 / w, b: bw / w, h: bh / w };
      ctx.clearRect(0, 0, w, w);
      ctx.drawImage(bild, lage.x * w, lage.y * w, bw, bh);
    };
    var fertigZeigen = function (url) { q('[data-anm4-logo-bild]').src = url; zeige('fertig'); };
    var stand = q('[data-anm4-logo-stand]');
    var sagen = function (t) { stand.textContent = t || ''; stand.hidden = !t; };
    this.logo = logoMerken();
    if (this.logo) fertigZeigen(this.logo); else zeige('leer');

    datei.addEventListener('change', function () {
      var f = datei.files && datei.files[0];
      datei.value = '';
      if (!f) return;
      if (['image/png', 'image/jpeg', 'image/webp'].indexOf(f.type) === -1) { sagen(MELDUNGEN.logo_typ); return; }
      if (f.size > 15 * 1024 * 1024) { sagen(MELDUNGEN.logo_gross); return; }
      sagen('');
      var url = URL.createObjectURL(f);
      var b = new Image();
      b.onload = function () {
        bild = b; zeige('schnitt'); zeichnen();
        r = { x: 0, y: 0, s: 1 };                     // Start: ganzes Logo im Rahmen
        rahmenSetzen(); URL.revokeObjectURL(url);
      };
      b.onerror = function () { sagen(MELDUNGEN.logo_typ); URL.revokeObjectURL(url); };
      b.src = url;
    });

    // Ziehen: Rahmen verschieben oder an einer Ecke groesser und kleiner ziehen (Gegenecke bleibt stehen)
    rahmen.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      var ecke = e.target.getAttribute && e.target.getAttribute('data-ecke');
      var gr = buehne.getBoundingClientRect();
      zug = { ecke: ecke, gr: gr, px: e.clientX, py: e.clientY, r0: { x: r.x, y: r.y, s: r.s } };
      try { rahmen.setPointerCapture(e.pointerId); } catch (f) { /* ohne Zeigerbindung weiter */ }
    });
    rahmen.addEventListener('pointermove', function (e) {
      if (!zug) return;
      var dx = (e.clientX - zug.px) / zug.gr.width, dy = (e.clientY - zug.py) / zug.gr.height;
      var a = zug.r0;
      if (!zug.ecke) {
        r.x = klemmen(a.x + dx, 0, 1 - a.s); r.y = klemmen(a.y + dy, 0, 1 - a.s);
      } else {
        // feste Gegenecke
        var fx = zug.ecke.indexOf('w') > -1 ? a.x + a.s : a.x;
        var fy = zug.ecke.indexOf('n') > -1 ? a.y + a.s : a.y;
        var mx = (zug.ecke.indexOf('w') > -1 ? a.x : a.x + a.s) + dx;
        var my = (zug.ecke.indexOf('n') > -1 ? a.y : a.y + a.s) + dy;
        var raumX = zug.ecke.indexOf('w') > -1 ? fx : 1 - fx;
        var raumY = zug.ecke.indexOf('n') > -1 ? fy : 1 - fy;
        var s = klemmen(Math.max(Math.abs(mx - fx), Math.abs(my - fy)), MIN, Math.min(raumX, raumY));
        r.s = s;
        r.x = zug.ecke.indexOf('w') > -1 ? fx - s : fx;
        r.y = zug.ecke.indexOf('n') > -1 ? fy - s : fy;
      }
      rahmenSetzen();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { rahmen.addEventListener(t, function () { zug = null; }); });

    q('[data-anm4-logo-ok]').addEventListener('click', function () {
      if (!bild || !lage) return;
      // Rahmeninhalt aus dem Originalbild: Bild so skalieren und verschieben, dass der Rahmen die Ausgabe fuellt
      var AUS = 480, aus = document.createElement('canvas');
      aus.width = AUS; aus.height = AUS;
      var k = AUS / r.s;                               // Buehnenanteil -> Ausgabepixel
      aus.getContext('2d').drawImage(bild, (lage.x - r.x) * k, (lage.y - r.y) * k, lage.b * k, lage.h * k);
      var url = aus.toDataURL('image/png');
      if (url.length > 1300000) url = aus.toDataURL('image/webp', 0.9);
      ich.logo = url;
      logoMerken(url);
      bild = null;
      fertigZeigen(url);
    });
    q('[data-anm4-logo-abbrechen]').addEventListener('click', function () { bild = null; if (ich.logo) fertigZeigen(ich.logo); else zeige('leer'); });
    q('[data-anm4-logo-aendern]').addEventListener('click', function () { datei.click(); });
    q('[data-anm4-logo-entfernen]').addEventListener('click', function () { ich.logo = ''; logoMerken(null); sagen(''); zeige('leer'); });
  };

  /* Mailadresse aendern (Michel 28.09.2026): Angaben bleiben, nur Login mit der neuen Adresse */
  Anmeldung.prototype.mailwechsel = function (code) {
    var ich = this;
    var el = this.el;
    var text = el.querySelector('[data-anm4-mw-text]');
    var knopf = el.querySelector('[data-anm4-mw-los]');
    var fehler = el.querySelector('[data-anm4-mw-fehler]');
    var zurueck = location.pathname + '?mail_bestaetigen=' + encodeURIComponent(code);
    var post = function (weg, body) {
      // Nach 25 Sekunden ohne Antwort nicht ewig warten
      var abbruch = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var uhr = abbruch ? setTimeout(function () { abbruch.abort(); }, 25000) : null;
      return fetch(ich.url + '/functions/v1/betrieb-anmelden/' + weg, {
        method: 'POST', headers: { apikey: ich.schluessel, 'Content-Type': 'application/json' }, body: JSON.stringify(body),
        signal: abbruch ? abbruch.signal : undefined
      }).then(function (r) { if (uhr) clearTimeout(uhr); return r.json().catch(function () { return {}; }); });
    };
    var zeigeFehler = function (t) { ich.zustand('mailwechsel'); el.querySelector('[data-anm4-mw-knoepfe]').hidden = true; ich.melden(t, fehler); };
    mwMerken(code);
    this.zustand('pruefen');
    post('mailwechsel/info', { code: code }).then(function (i) {
      if (i.status !== 'ok') { mwMerken(null); zeigeFehler(MELDUNGEN.mw_code); return; }
      var mail = String(i.mail || '');
      if (i.erledigt && !(ich.kunde && ich.kunde.kunde_mail === mail)) { mwMerken(null); zeigeFehler(MELDUNGEN.mw_erledigt); return; }
      if (ich.kunde && ich.kunde.kunde_mail === mail) {
        var d = { code: code };
        for (var k in ich.kunde) d[k] = ich.kunde[k];
        return post('mailwechsel', d).then(function (r) {
          if (r.status === 'ok') {
            mwMerken(null);
            if (history.replaceState) history.replaceState(null, '', location.pathname);
            ich.messen('mailwechsel_bestaetigt');
            ich.zustand('mailwechsel_fertig');
            return;
          }
          if (r.grund === 'code') mwMerken(null);
          zeigeFehler(r.grund === 'passt_nicht'
            ? MELDUNGEN.mw_passt_nicht + ' ' + (r.gruende || []).join(' ').replace(/^- /, '')
            : (MELDUNGEN['mw_' + r.grund] || MELDUNGEN[r.grund] || MELDUNGEN.server));
        });
      }
      ich.zustand('mailwechsel');
      if (ich.kunde) {
        // Noch mit der alten Adresse angemeldet: abmelden und mit der neuen anmelden
        text.textContent = 'Du bist noch mit deiner bisherigen Adresse angemeldet. Melde dich ab und mit der neuen Adresse an, um sie zu bestätigen.';
        knopf.querySelector('span').textContent = 'Abmelden und bestätigen';
        knopf.addEventListener('click', function (e) {
          e.preventDefault();
          ich.messen('mailwechsel_login_gestartet');
          abmeldenUndAnmelden(el, zurueck, mail);
        });
      } else {
        knopf.addEventListener('click', function (e) {
          e.preventDefault();
          ich.messen('mailwechsel_login_gestartet');
          location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(zurueck) + '&login_hint=' + encodeURIComponent(mail);
        });
      }
    }).catch(function () { zeigeFehler(MELDUNGEN.server); });
  };

  // Schritt 4 im Sitzungsspeicher des Tabs: { pflicht, gesendet }
  var SCHRITT4 = 'inst_anm4_schritt4';
  function schritt4Merken(neu) {
    try {
      if (neu === undefined) return JSON.parse(sessionStorage.getItem(SCHRITT4) || 'null');
      if (neu) sessionStorage.setItem(SCHRITT4, JSON.stringify(neu)); else sessionStorage.removeItem(SCHRITT4);
    } catch (e) { return null; }
  }

  Anmeldung.prototype.danke = function (j, wieder) {
    offenMerken(null);
    entwurfLoeschen();
    logoMerken(null);
    this.zustand('danke');
    var up = this.el.querySelector('[data-anm4-upload]');
    var reg = this.el.querySelector('[data-anm4-danke-register]');
    // upload = Nachweis ist Pflicht (kein Handelsregister). Eingetragene Firmen sehen den Kasten
    // als freiwillig (Michel 29.09.2026); ohne Login gibt es ihn nicht.
    var pflicht = !!(j && j.upload);
    this.pflicht = pflicht;
    try { sessionStorage.setItem('inst_anm4_pflicht', pflicht ? '1' : '0'); } catch (e) { /* ohne Speicher */ }
    up.hidden = !this.kunde;
    up.querySelector('[data-anm4-upload-pflicht]').hidden = !pflicht;
    up.querySelector('[data-anm4-upload-freiwillig]').hidden = pflicht;
    reg.hidden = pflicht;
    this.listeZeigen();
    schritt4Merken({ pflicht: pflicht, gesendet: !!(wieder && wieder.gesendet) });
    if (wieder && wieder.gesendet) this.nachweiseGesendetZeigen();
    // „Zum Partnerbereich“ erst nach dem Absenden, solange ein Pflicht-Upload offen ist nicht (Michel 29.09.)
    var pb = this.el.querySelector('[data-anm4-partnerbereich]');
    if (pb) pb.hidden = pflicht && !up.hidden;
    if (!wieder) this.el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  /*
    Nachweis-Upload (Michel 29.09.2026). Mehrere Nachweise nacheinander: Jede Datei lädt sofort hoch,
    sobald sie in der Dropzone liegt (assets/inst-dropzone.js meldet „inst-dz:datei“), mit rollender
    Zahl, Balken und Haken. Danach wandert sie in die Liste „Liegt bereit“ und die Dropzone ist frei
    für die nächste. Erst „Absenden“ bestätigt alle beim Server (aktion "fertig", je Datei). Die Liste
    übersteht ein Neuladen (Sitzungsspeicher); die Dateien liegen bis dahin schon im Speicher, nicht
    abgesendete räumt die Nachkontrolle nach einem Tag weg.
    Der Balken läuft mindestens MIN_ANIMATION lang, nie schneller als der echte Upload.
  */
  var MIN_ANIMATION = 1000;
  var LISTE = 'inst_anm4_nachweise';
  var ART_NAME = { gewerbeanmeldung: 'Gewerbeanmeldung', handwerksrolle: 'Handwerkskarte', meisterbrief: 'Meisterbrief', haftpflicht: 'Betriebshaftpflicht', netzbetreiber: 'Eintrag beim Netzbetreiber' };
  function listeLesen() { try { return JSON.parse(sessionStorage.getItem(LISTE) || '[]') || []; } catch (e) { return []; } }
  function listeMerken(l) { try { if (l && l.length) sessionStorage.setItem(LISTE, JSON.stringify(l)); else sessionStorage.removeItem(LISTE); } catch (e) { /* ohne Speicher */ } }
  function groesse(b) { return b >= 1e6 ? (b / 1e6).toFixed(1).replace('.', ',') + ' MB' : Math.max(1, Math.round(b / 1e3)) + ' KB'; }
  function htmlEsc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  Anmeldung.prototype.nachweisRufen = function (body) {
    var ich = this;
    var k = { kunde_id: ich.kunde.kunde_id, kunde_zeit: ich.kunde.kunde_zeit, kunde_sig: ich.kunde.kunde_sig };
    for (var x in body) k[x] = body[x];
    return fetch(ich.url + '/functions/v1/anmeldung-nachweis', {
      method: 'POST', headers: { apikey: ich.schluessel, 'Content-Type': 'application/json' }, body: JSON.stringify(k)
    }).then(function (r) { return r.json().catch(function () { return { status: 'fehler' }; }); });
  };

  Anmeldung.prototype.uploadEinrichten = function () {
    var ich = this;
    var kasten = this.el.querySelector('[data-anm4-upload]');
    if (!kasten) return;
    var label = kasten.querySelector('[data-anm4-upload-datei]').closest('label');
    this.nachweise = listeLesen();
    this.laeuft = false;
    try { this.pflicht = sessionStorage.getItem('inst_anm4_pflicht') === '1'; } catch (e) { this.pflicht = false; }
    label.addEventListener('inst-dz:datei', function (e) { ich.hochladen(e.detail.datei); });
    label.addEventListener('inst-dz:weg', function () { ich.laufNr = (ich.laufNr || 0) + 1; ich.laeuft = false; ich.listeZeigen(); });
    kasten.querySelector('[data-anm4-upload-liste]').addEventListener('click', function (e) {
      var weg = e.target.closest('[data-anm4-weg]');
      if (!weg) return;
      ich.nachweise.splice(Number(weg.getAttribute('data-anm4-weg')), 1);
      listeMerken(ich.nachweise);
      ich.listeZeigen();
    });
    kasten.querySelector('[data-anm4-upload-senden]').addEventListener('click', function () { ich.nachweisAbsenden(); });
    this.listeZeigen();
  };

  // Pflicht bei Einzelunternehmen (Michel 29.09.2026): Gewerbeanmeldung, als Handwerksbetrieb auch Handwerkskarte
  var PFLICHT_ARTEN = ['gewerbeanmeldung', 'handwerksrolle'];
  Anmeldung.prototype.listeZeigen = function () {
    var kasten = this.el.querySelector('[data-anm4-upload]');
    var l = this.nachweise || [];
    var pflicht = !!this.pflicht;
    var erfuellt = l.some(function (n) { return PFLICHT_ARTEN.indexOf(n.art) !== -1; });
    var punkt = kasten.querySelector('[data-anm4-pflicht-punkt]');
    if (punkt) { if (erfuellt) punkt.setAttribute('data-erfuellt', ''); else punkt.removeAttribute('data-erfuellt'); }
    kasten.querySelector('[data-anm4-pflicht-fehlt]').hidden = !(pflicht && l.length && !erfuellt);
    // Auswahl beschriften: in der Pflicht-Fassung „(Pflicht)“ und „(freiwillig)“
    [].forEach.call(kasten.querySelectorAll('[data-anm4-upload-art] option'), function (o) {
      var name = ART_NAME[o.value] || o.textContent;
      o.textContent = !pflicht ? name : name + (o.value === 'gewerbeanmeldung' ? ' (Pflicht)' : o.value === 'handwerksrolle' ? ' (statt Gewerbeanmeldung)' : ' (freiwillig)');
    });
    var liste = kasten.querySelector('[data-anm4-upload-liste]');
    kasten.querySelector('[data-anm4-upload-liste-kasten]').hidden = !l.length;
    liste.innerHTML = l.map(function (n, i) {
      return '<li class="inst-anm4-liste__eintrag">' +
        '<span class="inst-anm4-liste__haken" aria-hidden="true"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
        '<span class="inst-anm4-liste__text"><b>' + htmlEsc(ART_NAME[n.art] || n.art) +
          (pflicht ? ' <small class="inst-anm4-liste__marke' + (PFLICHT_ARTEN.indexOf(n.art) !== -1 ? ' inst-anm4-liste__marke--pflicht">Pflicht' : '">freiwillig') + '</small>' : '') +
          '</b><span>' + htmlEsc(n.name) + ' · ' + groesse(n.groesse) + '</span></span>' +
        '<button type="button" class="inst-anm4-liste__weg" data-anm4-weg="' + i + '" aria-label="' + htmlEsc(n.name) + ' entfernen"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '</li>';
    }).join('');
    var knopf = kasten.querySelector('[data-anm4-upload-senden]');
    knopf.hidden = !l.length;
    knopf.disabled = !!this.laeuft;
    kasten.querySelector('[data-anm4-upload-senden-text]').textContent = l.length === 1 ? 'Nachweis absenden' : l.length + ' Nachweise absenden';
    var dz = kasten.querySelector('[data-anm4-upload-datei]').closest('label').instDropzone;
    if (dz && !dz.datei) { dz.leerText = l.length ? 'Weitere Datei hierher ziehen' : 'Datei hierher ziehen'; dz.leer(); }
  };

  Anmeldung.prototype.uploadMelden = function (t) {
    var stand = this.el.querySelector('[data-anm4-upload-stand]');
    stand.textContent = t;
    stand.hidden = !t;
  };

  Anmeldung.prototype.hochladen = function (datei) {
    var ich = this;
    var kasten = this.el.querySelector('[data-anm4-upload]');
    var feld = kasten.querySelector('[data-anm4-upload-datei]');
    var dz = feld.closest('label').instDropzone;
    var art = kasten.querySelector('[data-anm4-upload-art]').value;
    var ende = function () { ich.laeuft = false; ich.listeZeigen(); };
    var fehler = function (t) { if (dz) dz.zurueck(t); ich.uploadMelden(t ? '' : 'Das hat nicht geklappt. Wähle die Datei noch einmal oder reiche sie später im Partnerbereich nach.'); ende(); };
    if (!datei) return;
    if (ERLAUBT.indexOf(datei.type) === -1) { fehler('Nur PDF, JPG, PNG oder WebP'); return; }
    if (datei.size > 2 * 1024 * 1024) { fehler('Zu groß, höchstens 2 MB'); return; }
    if (!this.kunde) { this.uploadMelden('Bitte lade die Datei im Partnerbereich hoch.'); return; }
    var nr = this.laufNr = (this.laufNr || 0) + 1;
    this.laeuft = true;
    this.listeZeigen();
    this.uploadMelden('');

    // Anzeige: echter Fortschritt, aber höchstens so schnell wie die Mindestdauer
    var beginn = Date.now(), echt = 0, pfad = null;
    var malen = function () {
      if (nr !== ich.laufNr) return;
      var p = Math.min(echt, (Date.now() - beginn) / MIN_ANIMATION);
      if (dz) dz.fortschritt(p);
      if (p >= 1 && pfad) {
        if (dz) dz.fertig();
        // kurz den Haken zeigen, dann in die Liste und die Box frei für die nächste Datei
        setTimeout(function () {
          if (nr !== ich.laufNr) return;
          ich.nachweise.push({ art: art, name: datei.name, groesse: datei.size, pfad: pfad });
          listeMerken(ich.nachweise);
          if (dz) dz.leeren('Weitere Datei hierher ziehen');
          ende();
        }, 900);
        return;
      }
      // setTimeout statt requestAnimationFrame: läuft auch weiter, wenn der Tab im Hintergrund liegt
      setTimeout(malen, 40);
    };
    if (dz) dz.fortschritt(0);
    setTimeout(malen, 40);

    this.nachweisRufen({ aktion: 'upload', art: art, typ: datei.type }).then(function (a) {
      if (a.status !== 'ok') throw a;
      // XMLHttpRequest statt fetch: nur so meldet der Browser den Upload-Fortschritt
      return new Promise(function (ok, nein) {
        var x = new XMLHttpRequest();
        x.open('PUT', a.url);
        x.setRequestHeader('Content-Type', datei.type);
        x.upload.onprogress = function (e) { if (e.lengthComputable) echt = Math.max(echt, 0.98 * e.loaded / e.total); };
        x.onload = function () { x.status >= 200 && x.status < 300 ? ok(a.pfad) : nein({ grund: 'upload' }); };
        x.onerror = function () { nein({ grund: 'upload' }); };
        x.send(datei);
      });
    }).then(function (p) {
      if (nr !== ich.laufNr) return;
      echt = 1;
      pfad = p;
    }).catch(function (e) {
      if (nr !== ich.laufNr) return;
      ich.laufNr++;
      fehler();
      if (e && e.grund === 'login') ich.uploadMelden('Deine Anmeldung ist abgelaufen. Bitte lade die Seite neu.');
    });
  };

  // Eigener Name: „absenden“ ist das Absenden des Anmeldeformulars (Schritt 2)
  Anmeldung.prototype.nachweisAbsenden = function () {
    var ich = this;
    var kasten = this.el.querySelector('[data-anm4-upload]');
    var knopf = kasten.querySelector('[data-anm4-upload-senden]');
    var offen = (this.nachweise || []).slice();
    if (!offen.length) { this.uploadMelden('Bitte zuerst eine Datei hochladen.'); return; }
    if (this.laeuft) return;
    knopf.disabled = true;
    this.uploadMelden('');
    var fehlgeschlagen = [];
    // nacheinander, damit die Drossel und die Teammails ruhig bleiben
    offen.reduce(function (kette, n) {
      return kette.then(function () {
        return ich.nachweisRufen({ aktion: 'fertig', pfad: n.pfad }).then(function (b) {
          if (b.status !== 'ok' && b.grund !== 'doppelt') fehlgeschlagen.push(n);
        }).catch(function () { fehlgeschlagen.push(n); });
      });
    }, Promise.resolve()).then(function () {
      ich.nachweise = fehlgeschlagen;
      listeMerken(fehlgeschlagen);
      if (fehlgeschlagen.length) {
        ich.listeZeigen();
        ich.uploadMelden((fehlgeschlagen.length === 1 ? 'Ein Nachweis konnte' : fehlgeschlagen.length + ' Nachweise konnten') + ' nicht übermittelt werden. Versuch es noch einmal oder reiche ihn im Partnerbereich nach.');
        return;
      }
      schritt4Merken({ pflicht: !!ich.pflicht, gesendet: true });
      ich.nachweiseGesendetZeigen();
    }).then(function () { knopf.disabled = false; });
  };

  // Nach dem Absenden kein Formular mehr, nur noch der Hinweis und der Weg in den Partnerbereich
  Anmeldung.prototype.nachweiseGesendetZeigen = function () {
    this.el.querySelector('[data-anm4-upload]').hidden = true;
    this.el.querySelector('[data-anm4-upload-fertig]').hidden = false;
    var pb = this.el.querySelector('[data-anm4-partnerbereich]');
    if (pb) pb.hidden = false;
  };

  function start() {
    document.querySelectorAll('[data-inst-anm4]').forEach(function (el) {
      if (!el.dataset.anm4Bereit) { el.dataset.anm4Bereit = '1'; new Anmeldung(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
